import { render, staticRenderFns } from "./SectionDiscussComponent.vue?vue&type=template&id=a373a270&scoped=true&"
import script from "./SectionDiscussComponent.vue?vue&type=script&lang=js&"
export * from "./SectionDiscussComponent.vue?vue&type=script&lang=js&"
import style0 from "./SectionDiscussComponent.vue?vue&type=style&index=0&id=a373a270&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a373a270",
  null
  
)

export default component.exports